import React from "react";
export default function CostPhotoListComponent(props){
  var {photo} = props.photo.data;
  let {t} = props;
  return (
    <div className="col-md-3 col-lg-4 col-sm-6 col-xs-6 costPhoto">
      <div className="cPhoto"><img onClick={() => {props.costImagePopupShow(window.costImages.url+photo)}} src={window.costImages.url+photo} width="100%"/></div>
      {
        props.photoDelete
        ?
        <a href="#" className="deleteCostPhoto" onClick = {() => {
            props.costPhotoDeleteButton(props.photo.data._id);
          }}>{t('removePhoto')}</a>
        :
        null
      }
    </div>
  );
}
